// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"806":"4163ae0c","2366":"1d2671aa"}[chunkId] || chunkId) + "." + {"806":"bf7ece7916944946","1110":"aa1a5597b66f7277","2227":"46b785537bc495e8","2366":"3dd3a126c06b8b96","5414":"74df86f214577381"}[chunkId] + ".js";
};